export const enhancementsData = [
  {
    key: 'Building Speed',
    type: 'dev',
    baseStat: 5.5,
    lvl1: { min: 1, max: 10, stat: 0.3 },
    lvl2: { min: 11, max: 20, stat: 0.5 },
    lvl3: { min: 21, max: 30, stat: 0 }
  },
  {
    key: 'Gather Speed Boost',
    type: 'dev',
    baseStat: 5.5,
    lvl1: { min: 1, max: 10, stat: 0.3 },
    lvl2: { min: 11, max: 20, stat: 0.5 },
    lvl3: { min: 21, max: 30, stat: 0 }
  },
  {
    key: 'Load Boost',
    type: 'dev',
    baseStat: 5.5,
    lvl1: { min: 1, max: 10, stat: 0.3 },
    lvl2: { min: 11, max: 20, stat: 0.5 },
    lvl3: { min: 21, max: 30, stat: 0 }
  },
  {
    key: 'March Speed',
    type: 'dev',
    baseStat: 5.5,
    lvl1: { min: 1, max: 10, stat: 0.3 },
    lvl2: { min: 11, max: 20, stat: 0.5 },
    lvl3: { min: 21, max: 30, stat: 0 }
  },
  {
    key: 'Monster Attack Speed',
    type: 'dev',
    baseStat: 5.5,
    lvl1: { min: 1, max: 10, stat: 0.3 },
    lvl2: { min: 11, max: 20, stat: 0.5 },
    lvl3: { min: 21, max: 30, stat: 0 }
  },
  {
    key: 'Recruitment Speed Up',
    type: 'dev',
    baseStat: 5.5,
    lvl1: { min: 1, max: 10, stat: 0.3 },
    lvl2: { min: 11, max: 20, stat: 0.5 },
    lvl3: { min: 21, max: 30, stat: 0 }
  },
  {
    key: 'Research Speed',
    type: 'dev',
    baseStat: 5.5,
    lvl1: { min: 1, max: 10, stat: 0.3 },
    lvl2: { min: 11, max: 20, stat: 0.5 },
    lvl3: { min: 21, max: 30, stat: 0 }
  },
  {
    key: 'Stamina Recovery',
    type: 'dev',
    baseStat: 5.5,
    lvl1: { min: 1, max: 10, stat: 0.3 },
    lvl2: { min: 11, max: 20, stat: 0.5 },
    lvl3: { min: 21, max: 30, stat: 0 }
  },
  {
    key: 'Wounded Limit Boost',
    type: 'dev',
    baseStat: 5.5,
    lvl1: { min: 1, max: 10, stat: 0.3 },
    lvl2: { min: 11, max: 20, stat: 0.5 },
    lvl3: { min: 21, max: 30, stat: 0 }
  },
  {
    key: 'Angel Attack',
    type: 'bas',
    baseStat: 6,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Angel Defense',
    type: 'bas',
    baseStat: 6,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Angel HP',
    type: 'bas',
    baseStat: 6,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Archer Attack',
    type: 'bas',
    baseStat: 6,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Archer Defense',
    type: 'bas',
    baseStat: 6,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Archer HP',
    type: 'bas',
    baseStat: 6,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Cavalry Attack',
    type: 'bas',
    baseStat: 6,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Cavalry Defense',
    type: 'bas',
    baseStat: 6,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Cavalry HP',
    type: 'bas',
    baseStat: 6,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Infantry Attack',
    type: 'bas',
    baseStat: 6,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Infantry Defense',
    type: 'bas',
    baseStat: 6,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Infantry HP',
    type: 'bas',
    baseStat: 6,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Mage Attack',
    type: 'bas',
    baseStat: 6,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Mage Defense',
    type: 'bas',
    baseStat: 6,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Mage HP',
    type: 'bas',
    baseStat: 6,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Golem Attack',
    type: 'gol',
    baseStat: 6.5,
    lvl1: { min: 1, max: 10, stat: 0 },
    lvl2: { min: 11, max: 20, stat: 0 },
    lvl3: { min: 21, max: 30, stat: 0 }
  },
  {
    key: 'Golem Defense',
    type: 'gol',
    baseStat: 6.5,
    lvl1: { min: 1, max: 10, stat: 0 },
    lvl2: { min: 11, max: 20, stat: 0 },
    lvl3: { min: 21, max: 30, stat: 0 }
  },
  {
    key: 'Golem HP',
    type: 'gol',
    baseStat: 6.5,
    lvl1: { min: 1, max: 10, stat: 0 },
    lvl2: { min: 11, max: 20, stat: 0 },
    lvl3: { min: 21, max: 30, stat: 0 }
  },
  {
    key: 'Golem Recruitment',
    type: 'gol',
    baseStat: 6.5,
    lvl1: { min: 1, max: 10, stat: 0 },
    lvl2: { min: 11, max: 20, stat: 0 },
    lvl3: { min: 21, max: 30, stat: 0 }
  },
  {
    key: 'Damage Against Angels Boost',
    type: 'pvp',
    baseStat: 9,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Damage Against Archers Boost',
    type: 'pvp',
    baseStat: 9,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Damage Against Cavalry Boost',
    type: 'pvp',
    baseStat: 9,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Damage Against Infantry Boost',
    type: 'pvp',
    baseStat: 9,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Damage Against Mages Boost',
    type: 'pvp',
    baseStat: 9,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Reduces Damage taken from Angels',
    type: 'pvp',
    baseStat: 9,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Reduces Damage taken from Archers',
    type: 'pvp',
    baseStat: 9,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Reduces Damage taken from Cavalry',
    type: 'pvp',
    baseStat: 9,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Reduces Damage taken from Infantry',
    type: 'pvp',
    baseStat: 9,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Reduces Damage taken from Mages',
    type: 'pvp',
    baseStat: 9,
    lvl1: { min: 1, max: 10, stat: 0.5 },
    lvl2: { min: 11, max: 20, stat: 0.8 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Damage Boost when Attacking',
    type: 'pvp',
    baseStat: 11.2,
    lvl1: { min: 1, max: 10, stat: 0.6 },
    lvl2: { min: 11, max: 20, stat: 0.9 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Damage Boost when Defending',
    type: 'pvp',
    baseStat: 11.2,
    lvl1: { min: 1, max: 10, stat: 0.6 },
    lvl2: { min: 11, max: 20, stat: 0.9 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Damage Taken Reduced when attacking',
    type: 'pvp',
    baseStat: 11.2,
    lvl1: { min: 1, max: 10, stat: 0.6 },
    lvl2: { min: 11, max: 20, stat: 0.9 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Damage Taken Reduced when defending',
    type: 'pvp',
    baseStat: 11.2,
    lvl1: { min: 1, max: 10, stat: 0.6 },
    lvl2: { min: 11, max: 20, stat: 0.9 },
    lvl3: { min: 21, max: 30, stat: 1.2 }
  },
  {
    key: 'Damage Taken Reduction in Elite Wars',
    type: 'evt',
    baseStat: 11.5,
    lvl1: { min: 1, max: 10, stat: 0.8 },
    lvl2: { min: 11, max: 20, stat: 1 },
    lvl3: { min: 21, max: 30, stat: 1.3 }
  },
  {
    key: 'Damage Taken Reduction in Realm Invasion',
    type: 'evt',
    baseStat: 11.5,
    lvl1: { min: 1, max: 10, stat: 0.8 },
    lvl2: { min: 11, max: 20, stat: 1 },
    lvl3: { min: 21, max: 30, stat: 1.3 }
  },
  {
    key: 'Increases Damage during Elite War',
    type: 'evt',
    baseStat: 11.5,
    lvl1: { min: 1, max: 10, stat: 0.8 },
    lvl2: { min: 11, max: 20, stat: 1 },
    lvl3: { min: 21, max: 30, stat: 1.3 }
  },
  {
    key: 'Increases Damage during Realm Invasion',
    type: 'evt',
    baseStat: 11.5,
    lvl1: { min: 1, max: 10, stat: 0.8 },
    lvl2: { min: 11, max: 20, stat: 1 },
    lvl3: { min: 21, max: 30, stat: 1.3 }
  },
  {
    key: 'Angel Limit',
    type: 'evt',
    baseStat: 650,
    lvl1: { min: 1, max: 10, stat: 75 },
    lvl2: { min: 11, max: 20, stat: 120 },
    lvl3: { min: 21, max: 30, stat: 150 }
  },
  {
    key: 'Army Size Limit',
    type: 'evt',
    baseStat: 650,
    lvl1: { min: 1, max: 10, stat: 75 },
    lvl2: { min: 11, max: 20, stat: 120 },
    lvl3: { min: 21, max: 30, stat: 150 }
  }
]

export const enhancementsEquipment = [
  {
    key: 1,
    slotDesc: 'Weapon',
    enhancements: [
      { desc: 'Angel Attack' },
      { desc: 'Archer Attack' },
      { desc: 'Building Speed' },
      { desc: 'Cavalry Attack' },
      { desc: 'Damage Against Angels Boost' },
      { desc: 'Damage Against Archers Boost' },
      { desc: 'Damage Against Cavalry Boost' },
      { desc: 'Damage Against Infantry Boost' },
      { desc: 'Damage Against Mages Boost' },
      { desc: 'Golem Attack' },
      { desc: 'Infantry Attack' },
      { desc: 'Mage Attack' },
      { desc: 'Stamina Recovery' },
      { desc: 'Wounded Limit Boost' }
    ]
  },
  {
    key: 2,
    slotDesc: 'Belt',
    enhancements: [
      { desc: 'Angel Limit' },
      { desc: 'Army Size Limit' },
      { desc: 'Damage Against Angels Boost' },
      { desc: 'Damage Against Archers Boost' },
      { desc: 'Damage Against Cavalry Boost' },
      { desc: 'Damage Against Infantry Boost' },
      { desc: 'Damage Against Mages Boost' },
      { desc: 'Damage Boost when Attacking' },
      { desc: 'Damage Boost when Defending' },
      { desc: 'Golem Attack' },
      { desc: 'Increases Damage during Elite War' },
      { desc: 'Increases Damage during Realm Invasion' },
      { desc: 'Recruitment Speed Up' },
      { desc: 'Wounded Limit Boost' }
    ]
  },
  {
    key: 3,
    slotDesc: 'Accessory',
    enhancements: [
      { desc: 'Angel Attack' },
      { desc: 'Angel Limit' },
      { desc: 'Archer Attack' },
      { desc: 'Army Size Limit' },
      { desc: 'Cavalry Attack' },
      { desc: 'Damage Boost when Attacking' },
      { desc: 'Damage Boost when Defending' },
      { desc: 'Golem Defense' },
      { desc: 'Golem Recruitment' },
      { desc: 'Increases Damage during Elite War' },
      { desc: 'Increases Damage during Realm Invasion' },
      { desc: 'Infantry Attack' },
      { desc: 'Load Boost' },
      { desc: 'Mage Attack' },
      { desc: 'Research Speed' }
    ]
  },
  {
    key: 4,
    slotDesc: 'Helmet',
    enhancements: [
      { desc: 'Angel HP' },
      { desc: 'Archer HP' },
      { desc: 'Cavalry HP' },
      { desc: 'Gather Speed Boost' },
      { desc: 'Golem HP' },
      { desc: 'Infantry HP' },
      { desc: 'Mage HP' },
      { desc: 'Monster Attack Speed' },
      { desc: 'Reduces Damage taken from Angels' },
      { desc: 'Reduces Damage taken from Archers' },
      { desc: 'Reduces Damage taken from Cavalry' },
      { desc: 'Reduces Damage taken from Infantry' },
      { desc: 'Reduces Damage taken from Mages' },
      { desc: 'Research Speed' }
    ]
  },
  {
    key: 5,
    slotDesc: 'Clothes',
    enhancements: [
      { desc: 'Angel Defense' },
      { desc: 'Archer Defense' },
      { desc: 'Cavalry Defense' },
      { desc: 'Golem Defense' },
      { desc: 'Infantry Defense' },
      { desc: 'Load Boost' },
      { desc: 'Mage Defense' },
      { desc: 'March Speed' },
      { desc: 'Recruitment Speed Up' },
      { desc: 'Reduces Damage taken from Angels' },
      { desc: 'Reduces Damage taken from Archers' },
      { desc: 'Reduces Damage taken from Cavalry' },
      { desc: 'Reduces Damage taken from Infantry' },
      { desc: 'Reduces Damage taken from Mages' }
    ]
  },
  {
    key: 6,
    slotDesc: 'Boots',
    enhancements: [
      { desc: 'Angel HP' },
      { desc: 'Archer HP' },
      { desc: 'Building Speed' },
      { desc: 'Cavalry HP' },
      { desc: 'Damage Taken Reduced when attacking' },
      { desc: 'Damage Taken Reduced when defending' },
      { desc: 'Damage Taken Reduction in Elite Wars' },
      { desc: 'Damage Taken Reduction in Realm Invasion' },
      { desc: 'Golem HP' },
      { desc: 'Golem Recruitment' },
      { desc: 'Infantry HP' },
      { desc: 'Mage HP' },
      { desc: 'Monster Attack Speed' },
      { desc: 'Wounded Limit Boost' }
    ]
  }
]

export const infoData = {
  key: 'obsidian',
  desc: 'Obsidian Level Chart',
  info: [
    { level: 1, quantity: 25 },
    { level: 2, quantity: 20 },
    { level: 3, quantity: 30 },
    { level: 4, quantity: 40 },
    { level: 5, quantity: 50 },
    { level: 6, quantity: 70 },
    { level: 7, quantity: 90 },
    { level: 8, quantity: 110 },
    { level: 9, quantity: 130 },
    { level: 10, quantity: 150 },
    { level: 11, quantity: 180 },
    { level: 12, quantity: 210 },
    { level: 13, quantity: 240 },
    { level: 14, quantity: 270 },
    { level: 15, quantity: 300 },
    { level: 16, quantity: 340 },
    { level: 17, quantity: 380 },
    { level: 18, quantity: 420 },
    { level: 19, quantity: 460 },
    { level: 20, quantity: 500 },
    { level: 21, quantity: 550 },
    { level: 22, quantity: 600 },
    { level: 23, quantity: 650 },
    { level: 24, quantity: 700 },
    { level: 25, quantity: 750 },
    { level: 26, quantity: 810 },
    { level: 27, quantity: 870 },
    { level: 28, quantity: 930 },
    { level: 29, quantity: 990 },
    { level: 30, quantity: 1050 }
  ]
}

export const packsData = [{ key: 'obsidian', level: 1, qty: 25, price: 4.99 }]

export const qualityList = [
  { option: 'Purple', maxEnhancement: 20 },
  { option: 'Orange', maxEnhancement: 30 }
]

export const equipmentList = [
  {
    level: 20,
    type: 'Weapon',
    desc: 'Black Dagger',
    troop: 'archer',
    materials: [
      { m: 'Wolf Fang', q: 1 },
      { m: 'Bone', q: 1 },
      { m: 'Steel Ingot', q: 1 },
      { m: 'Lumber', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 10.4 },
          { statDesc: 'Cavalry Attack', stat: 10.4 },
          { statDesc: 'Archer Attack', stat: 10.4 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 13 },
          { statDesc: 'Cavalry Attack', stat: 13 },
          { statDesc: 'Archer Attack', stat: 13 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Weapon',
    desc: 'Mage Staff',
    troop: 'mage',
    materials: [
      { m: 'Agate', q: 1 },
      { m: 'Wolf Fang', q: 1 },
      { m: 'Black Iron', q: 1 },
      { m: 'Rope', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Archer Attack', stat: 10.4 },
          { statDesc: 'Mage Attack', stat: 10.4 },
          { statDesc: 'Recruitment Speed Up', stat: 7.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Archer Attack', stat: 13 },
          { statDesc: 'Mage Attack', stat: 13 },
          { statDesc: 'Recruitment Speed Up', stat: 9.1 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Weapon',
    desc: 'Elder Scepter',
    troop: 'mage',
    materials: [
      { m: 'Black Iron', q: 1 },
      { m: 'Bone', q: 1 },
      { m: 'Bone', q: 1 },
      { m: 'Steel Ingot', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 10.4 },
          { statDesc: 'Infantry Attack', stat: 10.4 },
          { statDesc: 'Mage Attack', stat: 10.4 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 13 },
          { statDesc: 'Infantry Attack', stat: 13 },
          { statDesc: 'Mage Attack', stat: 13 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Weapon',
    desc: 'Traitors Kiss',
    troop: 'archer',
    materials: [
      { m: 'Fine Leather', q: 1 },
      { m: 'Soul Stone', q: 1 },
      { m: 'Bone', q: 1 },
      { m: 'Wolf Fang', q: 1 },
      { m: 'Agate', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 12.8 },
          { statDesc: 'Archer Attack', stat: 12.8 },
          { statDesc: 'Wounded Limit Boost', stat: 14 },
          { statDesc: 'Recruitment Speed Up', stat: 8.9 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 16 },
          { statDesc: 'Archer Attack', stat: 16 },
          { statDesc: 'Wounded Limit Boost', stat: 17.6 },
          { statDesc: 'Recruitment Speed Up', stat: 11.2 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Weapon',
    desc: 'Elemental Power',
    troop: 'archer',
    materials: [
      { m: 'Black Iron', q: 1 },
      { m: 'Feather', q: 1 },
      { m: 'Steel Ingot', q: 1 },
      { m: 'Wolf Fang', q: 1 },
      { m: 'Fine Leather', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 12.8 },
          { statDesc: 'Archer Attack', stat: 12.8 },
          { statDesc: 'March Speed', stat: 12.8 },
          { statDesc: 'Army Size Limit', stat: 2000 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 16 },
          { statDesc: 'Archer Attack', stat: 16 },
          { statDesc: 'March Speed', stat: 16 },
          { statDesc: 'Army Size Limit', stat: 2500 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Weapon',
    desc: 'Heart of Karlos',
    troop: 'mage',
    materials: [
      { m: 'Lumber', q: 1 },
      { m: 'Black Iron', q: 1 },
      { m: 'Bone', q: 1 },
      { m: 'Steel Ingot', q: 1 },
      { m: 'Steel Ingot', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 12.8 },
          { statDesc: 'Cavalry Attack', stat: 12.8 },
          { statDesc: 'Archer Attack', stat: 12.8 },
          { statDesc: 'Gollem Attack', stat: 19.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 16 },
          { statDesc: 'Cavalry Attack', stat: 16 },
          { statDesc: 'Archer Attack', stat: 16 },
          { statDesc: 'Gollem Attack', stat: 24 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Weapon',
    desc: 'Dusk Ode',
    troop: 'archer',
    materials: [
      { m: 'Lumber', q: 1 },
      { m: 'Wolf Fang', q: 1 },
      { m: 'Bone', q: 1 },
      { m: 'Wolf Fang', q: 1 },
      { m: 'Feather', q: 1 },
      { m: 'Steel Ingot', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 15.2 },
          { statDesc: 'Archer Attack', stat: 15.2 },
          { statDesc: 'Archer Attack', stat: 15.2 },
          { statDesc: 'March Speed', stat: 15.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 19 },
          { statDesc: 'Archer Attack', stat: 19 },
          { statDesc: 'Archer Attack', stat: 19 },
          { statDesc: 'March Speed', stat: 19 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Weapon',
    desc: 'Wild Thunder',
    troop: 'archer',
    materials: [
      { m: 'Rope', q: 1 },
      { m: 'Steel Ingot', q: 1 },
      { m: 'Steel Ingot', q: 1 },
      { m: 'Wolf Fang', q: 1 },
      { m: 'Magic Spar', q: 1 },
      { m: 'Bone', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 15.2 },
          { statDesc: 'Archer Attack', stat: 15.2 },
          { statDesc: 'Gollem Attack', stat: 22.8 },
          { statDesc: 'Golem Recruitment', stat: 18.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 19 },
          { statDesc: 'Archer Attack', stat: 19 },
          { statDesc: 'Gollem Attack', stat: 28.5 },
          { statDesc: 'Golem Recruitment', stat: 22.8 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Weapon',
    desc: 'Holy Crossbow',
    troop: 'mage',
    materials: [
      { m: 'Wolf Fang', q: 1 },
      { m: 'Agate', q: 1 },
      { m: 'Black Iron', q: 1 },
      { m: 'Black Iron', q: 1 },
      { m: 'Fine Leather', q: 1 },
      { m: 'Bone', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Mage Attack', stat: 15.2 },
          { statDesc: 'Mage Attack', stat: 15.2 },
          { statDesc: 'Recruitment Speed Up', stat: 10.6 },
          { statDesc: 'Army Size Limit', stat: 2400 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Mage Attack', stat: 19 },
          { statDesc: 'Mage Attack', stat: 19 },
          { statDesc: 'Recruitment Speed Up', stat: 13.3 },
          { statDesc: 'Army Size Limit', stat: 3000 }
        ]
      }
    ]
  },
  {
    level: 35,
    type: 'Weapon',
    desc: 'Fiery Crossbow',
    troop: 'archer',
    materials: [
      { m: 'Wolf Fang', q: 2 },
      { m: 'Agate', q: 2 },
      { m: 'Black Iron', q: 2 },
      { m: 'Bone', q: 2 },
      { m: 'Crystal', q: 2 },
      { m: 'Fine Leather', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Archer Attack', stat: 16.7 },
          { statDesc: 'Archer Attack', stat: 16.7 },
          { statDesc: 'Cavalry Attack', stat: 16.7 },
          { statDesc: 'March Speed', stat: 17.6 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Archer Attack', stat: 21 },
          { statDesc: 'Archer Attack', stat: 21 },
          { statDesc: 'Cavalry Attack', stat: 21 },
          { statDesc: 'March Speed', stat: 22 }
        ]
      }
    ]
  },
  {
    level: 35,
    type: 'Weapon',
    desc: 'Mastery Staff',
    troop: 'mage',
    materials: [
      { m: 'Soul Stone', q: 2 },
      { m: 'Lumber', q: 2 },
      { m: 'Black Iron', q: 2 },
      { m: 'Bone', q: 2 },
      { m: 'Palm Leaf', q: 2 },
      { m: 'Magic Spar', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Mage Attack', stat: 16.7 },
          { statDesc: 'Mage Attack', stat: 16.7 },
          { statDesc: 'Army Size Limit', stat: 2900 },
          { statDesc: 'Gollem Attack', stat: 26.5 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Mage Attack', stat: 21 },
          { statDesc: 'Mage Attack', stat: 21 },
          { statDesc: 'Army Size Limit', stat: 3600 },
          { statDesc: 'Gollem Attack', stat: 33.1 }
        ]
      }
    ]
  },
  {
    level: 40,
    type: 'Weapon',
    desc: 'Dragon Scorch Sword',
    troop: 'archer',
    materials: [
      { m: 'Magic Spar', q: 2 },
      { m: 'Lumber', q: 2 },
      { m: 'Steel Ingot', q: 2 },
      { m: 'Bone', q: 2 },
      { m: 'Crystal', q: 2 },
      { m: 'Wolf Fang', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Archer Attack', stat: 18.9 },
          { statDesc: 'Archer Attack', stat: 18.9 },
          { statDesc: 'Cavalry Attack', stat: 18.9 },
          { statDesc: 'March Speed', stat: 20 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Archer Attack', stat: 23.8 },
          { statDesc: 'Archer Attack', stat: 23.8 },
          { statDesc: 'Cavalry Attack', stat: 23.8 },
          { statDesc: 'March Speed', stat: 25 }
        ]
      }
    ]
  },
  {
    level: 40,
    type: 'Weapon',
    desc: 'Dragonshard Staff',
    troop: 'mage',
    materials: [
      { m: 'Soul Stone', q: 2 },
      { m: 'Agate', q: 2 },
      { m: 'Black Iron', q: 2 },
      { m: 'Bone', q: 2 },
      { m: 'Palm Leaf', q: 2 },
      { m: 'Fine Leather', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Mage Attack', stat: 18.9 },
          { statDesc: 'Mage Attack', stat: 18.9 },
          { statDesc: 'Army Size Limit', stat: 3500 },
          { statDesc: 'Gollem Attack', stat: 30.4 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Mage Attack', stat: 23.8 },
          { statDesc: 'Mage Attack', stat: 23.8 },
          { statDesc: 'Army Size Limit', stat: 4300 },
          { statDesc: 'Gollem Attack', stat: 37.9 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Belt',
    desc: 'Scale Belt',
    troop: 'infantry/cavalry',
    materials: [
      { m: 'Soul Cloth', q: 1 },
      { m: 'Crystal', q: 1 },
      { m: 'Soul Stone', q: 1 },
      { m: 'Thick Hide', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry HP', stat: 10.4 },
          { statDesc: 'Cavalry HP', stat: 10.4 },
          { statDesc: 'Healing Speed', stat: 10.4 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry HP', stat: 13 },
          { statDesc: 'Cavalry HP', stat: 13 },
          { statDesc: 'Healing Speed', stat: 13 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Belt',
    desc: 'Silk Sash',
    troop: 'mage',
    materials: [
      { m: 'Palm Leaf', q: 1 },
      { m: 'Bone', q: 1 },
      { m: 'Black Iron', q: 1 },
      { m: 'Soul Stone', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 10.4 },
          { statDesc: 'Mage Attack', stat: 10.4 },
          { statDesc: 'Monster Attack Speed', stat: 20.8 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 13 },
          { statDesc: 'Mage Attack', stat: 13 },
          { statDesc: 'Monster Attack Speed', stat: 26 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Belt',
    desc: 'Prayer Belt',
    troop: 'development',
    materials: [
      { m: 'Palm Leaf', q: 1 },
      { m: 'Thick Hide', q: 1 },
      { m: 'Rope', q: 1 },
      { m: 'Lumber', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Gather Speed Boost', stat: 14.5 },
          { statDesc: 'Load Boost', stat: 17.6 },
          { statDesc: 'Stamina Recovery', stat: 10.4 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Gather Speed Boost', stat: 18.2 },
          { statDesc: 'Load Boost', stat: 22.1 },
          { statDesc: 'Stamina Recovery', stat: 13 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Accessory',
    desc: 'Sage Ring',
    troop: 'infantry/cavalry',
    materials: [
      { m: 'Thick Hide', q: 1 },
      { m: 'Bone', q: 1 },
      { m: 'Black Iron', q: 1 },
      { m: 'Lumber', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 10.4 },
          { statDesc: 'Cavalry Attack', stat: 10.4 },
          { statDesc: 'Research Speed', stat: 10.4 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 13 },
          { statDesc: 'Cavalry Attack', stat: 13 },
          { statDesc: 'Research Speed', stat: 13 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Accessory',
    desc: 'Gaia Ring',
    troop: 'infantry',
    materials: [
      { m: 'Palm Leaf', q: 1 },
      { m: 'Bone', q: 1 },
      { m: 'Bone', q: 1 },
      { m: 'Crystal', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 10.4 },
          { statDesc: 'Infantry Attack', stat: 10.4 },
          { statDesc: 'Monster Attack Speed', stat: 20.8 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 13 },
          { statDesc: 'Infantry Attack', stat: 13 },
          { statDesc: 'Monster Attack Speed', stat: 26 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Accessory',
    desc: 'Holy Truth',
    troop: 'mage',
    materials: [
      { m: 'Magic Spar', q: 1 },
      { m: 'Bone', q: 1 },
      { m: 'Black Iron', q: 1 },
      { m: 'Rope', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 10.4 },
          { statDesc: 'Mage Attack', stat: 10.4 },
          { statDesc: 'Building Speed', stat: 10.4 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 13 },
          { statDesc: 'Mage Attack', stat: 13 },
          { statDesc: 'Building Speed', stat: 13 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Helmet',
    desc: 'Satin Hood',
    troop: 'infantry/cavalry',
    materials: [
      { m: 'Agate', q: 1 },
      { m: 'Crystal', q: 1 },
      { m: 'Soul Stone', q: 1 },
      { m: 'Crystal', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry HP', stat: 10.4 },
          { statDesc: 'Cavalry HP', stat: 10.4 },
          { statDesc: 'Recruitment Speed Up', stat: 7.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry HP', stat: 13 },
          { statDesc: 'Cavalry HP', stat: 13 },
          { statDesc: 'Recruitment Speed Up', stat: 9.1 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Helmet',
    desc: 'Assassin Cape',
    troop: 'infantry',
    materials: [
      { m: 'Crystal', q: 1 },
      { m: 'Lumber', q: 1 },
      { m: 'Agate', q: 1 },
      { m: 'Soul Cloth', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Archer HP', stat: 10.4 },
          { statDesc: 'Mage HP', stat: 10.4 },
          { statDesc: 'Infantry HP', stat: 10.4 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Archer HP', stat: 13 },
          { statDesc: 'Mage HP', stat: 13 },
          { statDesc: 'Infantry HP', stat: 13 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Helmet',
    desc: 'Ceremonial Hat',
    troop: 'cavalry',
    materials: [
      { m: 'Soul Stone', q: 1 },
      { m: 'Lumber', q: 1 },
      { m: 'Lumber', q: 1 },
      { m: 'Lumber', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Archer HP', stat: 10.4 },
          { statDesc: 'Archer HP', stat: 10.4 },
          { statDesc: 'Cavalry HP', stat: 10.4 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Archer HP', stat: 13 },
          { statDesc: 'Archer HP', stat: 13 },
          { statDesc: 'Cavalry HP', stat: 13 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Clothes',
    desc: 'Scale Shirt',
    troop: 'development',
    materials: [
      { m: 'Magic Spar', q: 1 },
      { m: 'Magic Spar', q: 1 },
      { m: 'Feather', q: 1 },
      { m: 'Magic Spar', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Mage Defense', stat: 10.4 },
          { statDesc: 'Archer Defense', stat: 10.4 },
          { statDesc: 'Building Speed', stat: 10.4 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Mage Defense', stat: 13 },
          { statDesc: 'Archer Defense', stat: 13 },
          { statDesc: 'Building Speed', stat: 13 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Clothes',
    desc: 'Fine Tunic',
    troop: 'infantry',
    materials: [
      { m: 'Soul Cloth', q: 1 },
      { m: 'Magic Spar', q: 1 },
      { m: 'Soul Cloth', q: 1 },
      { m: 'Soul Cloth', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Mage Defense', stat: 10.4 },
          { statDesc: 'Infantry Defense', stat: 10.4 },
          { statDesc: 'Healing Speed', stat: 10.4 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Mage Defense', stat: 13 },
          { statDesc: 'Infantry Defense', stat: 13 },
          { statDesc: 'Healing Speed', stat: 13 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Clothes',
    desc: 'Mage Robes',
    troop: 'infantry/cavalry',
    materials: [
      { m: 'Agate', q: 1 },
      { m: 'Fine Leather', q: 1 },
      { m: 'Soul Cloth', q: 1 },
      { m: 'Rope', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Cavalry Defense', stat: 10.4 },
          { statDesc: 'Infantry Defense', stat: 10.4 },
          { statDesc: 'Recruitment Speed Up', stat: 7.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Cavalry Defense', stat: 13 },
          { statDesc: 'Infantry Defense', stat: 13 },
          { statDesc: 'Recruitment Speed Up', stat: 9.1 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Boots',
    desc: 'Mage Boots',
    troop: 'development',
    materials: [
      { m: 'Palm Leaf', q: 1 },
      { m: 'Lumber', q: 1 },
      { m: 'Palm Leaf', q: 1 },
      { m: 'Magic Spar', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Archer HP', stat: 10.4 },
          { statDesc: 'Monster Attack Speed', stat: 20.8 },
          { statDesc: 'Stamina Recovery', stat: 10.4 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Archer HP', stat: 13 },
          { statDesc: 'Monster Attack Speed', stat: 26 },
          { statDesc: 'Stamina Recovery', stat: 13 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Boots',
    desc: 'Scale Boots',
    troop: 'cavalry',
    materials: [
      { m: 'Thick Hide', q: 1 },
      { m: 'Steel Ingot', q: 1 },
      { m: 'Rope', q: 1 },
      { m: 'Palm Leaf', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 10.4 },
          { statDesc: 'Load Boost', stat: 17.6 },
          { statDesc: 'Gather Speed Boost', stat: 14.5 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 13 },
          { statDesc: 'Load Boost', stat: 22.1 },
          { statDesc: 'Gather Speed Boost', stat: 18.2 }
        ]
      }
    ]
  },
  {
    level: 20,
    type: 'Boots',
    desc: 'Fine Boots',
    troop: 'development',
    materials: [
      { m: 'Steel Ingot', q: 1 },
      { m: 'Thick Hide', q: 1 },
      { m: 'Fine Leather', q: 1 },
      { m: 'Rope', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Gather Speed Boost', stat: 14.5 },
          { statDesc: 'Golem HP', stat: 15.6 },
          { statDesc: 'Golem Attack', stat: 15.6 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Gather Speed Boost', stat: 18.2 },
          { statDesc: 'Golem HP', stat: 19.5 },
          { statDesc: 'Golem Attack', stat: 19.5 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Belt',
    desc: 'Blood Belt',
    troop: 'mage',
    materials: [
      { m: 'Lumber', q: 1 },
      { m: 'Magic Spar', q: 1 },
      { m: 'Bone', q: 1 },
      { m: 'Black Iron', q: 1 },
      { m: 'Thick Hide', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 12.8 },
          { statDesc: 'Mage Attack', stat: 12.8 },
          { statDesc: 'Building Speed', stat: 12.8 },
          { statDesc: 'Research Speed', stat: 12.8 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 16 },
          { statDesc: 'Mage Attack', stat: 16 },
          { statDesc: 'Building Speed', stat: 16 },
          { statDesc: 'Research Speed', stat: 16 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Belt',
    desc: 'Element Belt',
    troop: 'infantry/cavalry',
    materials: [
      { m: 'Thick Hide', q: 1 },
      { m: 'Soul Stone', q: 1 },
      { m: 'Crystal', q: 1 },
      { m: 'Soul Stone', q: 1 },
      { m: 'Soul Cloth', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry HP', stat: 12.8 },
          { statDesc: 'Cavalry HP', stat: 12.8 },
          { statDesc: 'Wounded Limit Boost', stat: 14 },
          { statDesc: 'Healing Speed', stat: 12.8 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry HP', stat: 16 },
          { statDesc: 'Cavalry HP', stat: 16 },
          { statDesc: 'Wounded Limit Boost', stat: 17.6 },
          { statDesc: 'Healing Speed', stat: 16 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Belt',
    desc: 'Resilent Belt',
    troop: 'development',
    materials: [
      { m: 'Feather', q: 1 },
      { m: 'Palm Leaf', q: 1 },
      { m: 'Thick Hide', q: 1 },
      { m: 'Rope', q: 1 },
      { m: 'Agate', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Gather Speed Boost', stat: 17.9 },
          { statDesc: 'Load Boost', stat: 21.7 },
          { statDesc: 'Stamina Recovery', stat: 12.8 },
          { statDesc: 'Recruitment Speed Up', stat: 8.9 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Gather Speed Boost', stat: 22.4 },
          { statDesc: 'Load Boost', stat: 27.2 },
          { statDesc: 'Stamina Recovery', stat: 16 },
          { statDesc: 'Recruitment Speed Up', stat: 11.2 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Accessory',
    desc: 'Blood Ring',
    troop: 'archer',
    materials: [
      { m: 'Rope', q: 1 },
      { m: 'Soul Stone', q: 1 },
      { m: 'Steel Ingot', q: 1 },
      { m: 'Wolf Fang', q: 1 },
      { m: 'Soul Cloth', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 12.8 },
          { statDesc: 'Archer Attack', stat: 12.8 },
          { statDesc: 'Wounded Limit Boost', stat: 14 },
          { statDesc: 'Healing Speed', stat: 12.8 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 16 },
          { statDesc: 'Archer Attack', stat: 16 },
          { statDesc: 'Wounded Limit Boost', stat: 17.6 },
          { statDesc: 'Healing Speed', stat: 16 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Accessory',
    desc: 'Thorn Stone',
    troop: 'archer',
    materials: [
      { m: 'Lumber', q: 1 },
      { m: 'Magic Spar', q: 1 },
      { m: 'Bone', q: 1 },
      { m: 'Wolf Fang', q: 1 },
      { m: 'Thick Hide', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 12.8 },
          { statDesc: 'Archer Attack', stat: 12.8 },
          { statDesc: 'Building Speed', stat: 12.8 },
          { statDesc: 'Research Speed', stat: 12.8 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 16 },
          { statDesc: 'Archer Attack', stat: 16 },
          { statDesc: 'Building Speed', stat: 16 },
          { statDesc: 'Research Speed', stat: 16 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Accessory',
    desc: 'Brave Heart',
    troop: 'mage',
    materials: [
      { m: 'Soul Cloth', q: 1 },
      { m: 'Palm Leaf', q: 1 },
      { m: 'Wolf Fang', q: 1 },
      { m: 'Black Iron', q: 1 },
      { m: 'Palm Leaf', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Archer Attack', stat: 12.8 },
          { statDesc: 'Mage Attack', stat: 12.8 },
          { statDesc: 'Stamina Recovery', stat: 12.8 },
          { statDesc: 'Monster Attack Speed', stat: 25.6 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Archer Attack', stat: 16 },
          { statDesc: 'Mage Attack', stat: 16 },
          { statDesc: 'Stamina Recovery', stat: 16 },
          { statDesc: 'Monster Attack Speed', stat: 25.6 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Helmet',
    desc: 'Element Helmet',
    troop: 'infantry',
    materials: [
      { m: 'Feather', q: 1 },
      { m: 'Feather', q: 1 },
      { m: 'Agate', q: 1 },
      { m: 'Crystal', q: 1 },
      { m: 'Fine Leather', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Mage HP', stat: 12.8 },
          { statDesc: 'Infantry HP', stat: 12.8 },
          { statDesc: 'March Speed', stat: 12.8 },
          { statDesc: 'Army Size Limit', stat: 2000 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Mage HP', stat: 16 },
          { statDesc: 'Infantry HP', stat: 16 },
          { statDesc: 'March Speed', stat: 16 },
          { statDesc: 'Army Size Limit', stat: 2500 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Helmet',
    desc: 'Occult Helmet',
    troop: 'infantry',
    materials: [
      { m: 'Magic Spar', q: 1 },
      { m: 'Soul Stone', q: 1 },
      { m: 'Lumber', q: 1 },
      { m: 'Crystal', q: 1 },
      { m: 'Agate', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Archer HP', stat: 12.8 },
          { statDesc: 'Infantry HP', stat: 12.8 },
          { statDesc: 'Wounded Limit Boost', stat: 14 },
          { statDesc: 'Recruitment Speed Up', stat: 8.9 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Archer HP', stat: 16 },
          { statDesc: 'Infantry HP', stat: 16 },
          { statDesc: 'Wounded Limit Boost', stat: 17.6 },
          { statDesc: 'Recruitment Speed Up', stat: 11.2 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Helmet',
    desc: 'Blood Helmet',
    troop: 'cavalry',
    materials: [
      { m: 'Crystal', q: 1 },
      { m: 'Soul Stone', q: 1 },
      { m: 'Lumber', q: 1 },
      { m: 'Agate', q: 1 },
      { m: 'Fine Leather', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Archer HP', stat: 12.8 },
          { statDesc: 'Mage HP', stat: 12.8 },
          { statDesc: 'Cavalry HP', stat: 12.8 },
          { statDesc: 'Golem HP', stat: 19.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Archer HP', stat: 16 },
          { statDesc: 'Mage HP', stat: 16 },
          { statDesc: 'Cavalry HP', stat: 16 },
          { statDesc: 'Golem HP', stat: 24 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Clothes',
    desc: 'Shining Armor',
    troop: 'cavalry',
    materials: [
      { m: 'Crystal', q: 1 },
      { m: 'Soul Stone', q: 1 },
      { m: 'Magic Spar', q: 1 },
      { m: 'Fine Leather', q: 1 },
      { m: 'Agate', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Mage Defense', stat: 12.8 },
          { statDesc: 'Cavalry Defense', stat: 12.8 },
          { statDesc: 'Wounded Limit Boost', stat: 14 },
          { statDesc: 'Recruitment Speed Up', stat: 8.9 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Mage Defense', stat: 16 },
          { statDesc: 'Cavalry Defense', stat: 16 },
          { statDesc: 'Wounded Limit Boost', stat: 17.6 },
          { statDesc: 'Recruitment Speed Up', stat: 11.2 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Clothes',
    desc: 'Blood Armor',
    troop: 'development',
    materials: [
      { m: 'Lumber', q: 1 },
      { m: 'Palm Leaf', q: 1 },
      { m: 'Magic Spar', q: 1 },
      { m: 'Feather', q: 1 },
      { m: 'Feather', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Mage Defense', stat: 12.8 },
          { statDesc: 'Archer Defense', stat: 12.8 },
          { statDesc: 'Monster Attack Speed', stat: 25.6 },
          { statDesc: 'March Speed', stat: 12.8 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Mage Defense', stat: 16 },
          { statDesc: 'Archer Defense', stat: 16 },
          { statDesc: 'Monster Attack Speed', stat: 32 },
          { statDesc: 'March Speed', stat: 16 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Clothes',
    desc: 'Elven Armor',
    troop: 'cavalry',
    materials: [
      { m: 'Rope', q: 1 },
      { m: 'Feather', q: 1 },
      { m: 'Feather', q: 1 },
      { m: 'Fine Leather', q: 1 },
      { m: 'Soul Cloth', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Archer Defense', stat: 12.8 },
          { statDesc: 'Cavalry Defense', stat: 12.8 },
          { statDesc: 'March Speed', stat: 12.8 },
          { statDesc: 'Healing Speed', stat: 12.8 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Archer Defense', stat: 16 },
          { statDesc: 'Cavalry Defense', stat: 16 },
          { statDesc: 'March Speed', stat: 16 },
          { statDesc: 'Healing Speed', stat: 16 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Boots',
    desc: 'Blood Boots',
    troop: 'archer/monsters',
    materials: [
      { m: 'Crystal', q: 1 },
      { m: 'Palm Leaf', q: 1 },
      { m: 'Steel Ingot', q: 1 },
      { m: 'Wolf Fang', q: 1 },
      { m: 'Palm Leaf', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 12.8 },
          { statDesc: 'Archer Attack', stat: 12.8 },
          { statDesc: 'Monster Attack Speed', stat: 25.6 },
          { statDesc: 'Stamina Recovery', stat: 12.8 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 16 },
          { statDesc: 'Archer Attack', stat: 16 },
          { statDesc: 'Monster Attack Speed', stat: 32 },
          { statDesc: 'Stamina Recovery', stat: 16 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Boots',
    desc: 'Dwarf Boots',
    troop: 'archer/mage',
    materials: [
      { m: 'Magic Spar', q: 1 },
      { m: 'Rope', q: 1 },
      { m: 'Lumber', q: 1 },
      { m: 'Agate', q: 1 },
      { m: 'Thick Hide', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Archer HP', stat: 12.8 },
          { statDesc: 'Mage HP', stat: 12.8 },
          { statDesc: 'Load Boost', stat: 21.7 },
          { statDesc: 'Gather Speed Boost', stat: 17.9 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Archer HP', stat: 16 },
          { statDesc: 'Mage HP', stat: 16 },
          { statDesc: 'Load Boost', stat: 27.2 },
          { statDesc: 'Gather Speed Boost', stat: 22.4 }
        ]
      }
    ]
  },
  {
    level: 25,
    type: 'Boots',
    desc: 'Armored Boots',
    troop: 'development',
    materials: [
      { m: 'Black Iron', q: 1 },
      { m: 'Rope', q: 1 },
      { m: 'Fine Leather', q: 1 },
      { m: 'Steel Ingot', q: 1 },
      { m: 'Soul Stone', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Golem HP', stat: 19.2 },
          { statDesc: 'Golem Attack', stat: 19.2 },
          { statDesc: 'Golem Defense', stat: 19.2 },
          { statDesc: 'Wounded Limit Boost', stat: 14 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Golem HP', stat: 24 },
          { statDesc: 'Golem Attack', stat: 24 },
          { statDesc: 'Golem Defense', stat: 24 },
          { statDesc: 'Wounded Limit Boost', stat: 17.6 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Belt',
    desc: 'Sacret Belt',
    troop: 'mage',
    materials: [
      { m: 'Lumber', q: 1 },
      { m: 'Magic Spar', q: 1 },
      { m: 'Bone', q: 1 },
      { m: 'Black Iron', q: 1 },
      { m: 'Thick Hide', q: 1 },
      { m: 'Soul Cloth', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 15.2 },
          { statDesc: 'Mage Attack', stat: 15.2 },
          { statDesc: 'Building Speed', stat: 15.2 },
          { statDesc: 'Research Speed', stat: 15.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 19 },
          { statDesc: 'Mage Attack', stat: 19 },
          { statDesc: 'Building Speed', stat: 19 },
          { statDesc: 'Research Speed', stat: 19 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Belt',
    desc: 'Blessing Belt',
    troop: 'infantry/cavalry',
    materials: [
      { m: 'Thick Hide', q: 1 },
      { m: 'Soul Stone', q: 1 },
      { m: 'Crystal', q: 1 },
      { m: 'Soul Stone', q: 1 },
      { m: 'Soul Cloth', q: 1 },
      { m: 'Feather', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry HP', stat: 15.2 },
          { statDesc: 'Cavalry HP', stat: 15.2 },
          { statDesc: 'Wounded Limit Boost', stat: 16.7 },
          { statDesc: 'Healing Speed', stat: 15.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry HP', stat: 19 },
          { statDesc: 'Cavalry HP', stat: 19 },
          { statDesc: 'Wounded Limit Boost', stat: 20.9 },
          { statDesc: 'Healing Speed', stat: 19 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Belt',
    desc: 'Dragonscale Belt',
    troop: 'development',
    materials: [
      { m: 'Magic Spar', q: 1 },
      { m: 'Palm Leaf', q: 1 },
      { m: 'Thick Hide', q: 1 },
      { m: 'Rope', q: 1 },
      { m: 'Agate', q: 1 },
      { m: 'Fine Leather', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Gather Speed Boost', stat: 21.2 },
          { statDesc: 'Load Boost', stat: 25.8 },
          { statDesc: 'Stamina Recovery', stat: 15.2 },
          { statDesc: 'Recruitment Speed Up', stat: 10.6 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Gather Speed Boost', stat: 26.6 },
          { statDesc: 'Load Boost', stat: 32.3 },
          { statDesc: 'Stamina Recovery', stat: 19 },
          { statDesc: 'Recruitment Speed Up', stat: 13.3 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Accessory',
    desc: 'Holy Blessing',
    troop: 'mage',
    materials: [
      { m: 'Crystal', q: 1 },
      { m: 'Magic Spar', q: 1 },
      { m: 'Bone', q: 1 },
      { m: 'Black Iron', q: 1 },
      { m: 'Thick Hide', q: 1 },
      { m: 'Soul Stone', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 15.2 },
          { statDesc: 'Mage Attack', stat: 15.2 },
          { statDesc: 'Building Speed', stat: 15.2 },
          { statDesc: 'Research Speed', stat: 15.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 19 },
          { statDesc: 'Mage Attack', stat: 19 },
          { statDesc: 'Building Speed', stat: 19 },
          { statDesc: 'Research Speed', stat: 19 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Accessory',
    desc: 'Noble Badge',
    troop: 'infantry/cavalry',
    materials: [
      { m: 'Lumber', q: 1 },
      { m: 'Soul Stone', q: 1 },
      { m: 'Bone', q: 1 },
      { m: 'Steel Ingot', q: 1 },
      { m: 'Soul Cloth', q: 1 },
      { m: 'Rope', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 15.2 },
          { statDesc: 'Cavalry Attack', stat: 15.2 },
          { statDesc: 'Wounded Limit Boost', stat: 16.7 },
          { statDesc: 'Healing Speed', stat: 15.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 19 },
          { statDesc: 'Cavalry Attack', stat: 19 },
          { statDesc: 'Wounded Limit Boost', stat: 20.9 },
          { statDesc: 'Healing Speed', stat: 19 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Accessory',
    desc: 'Dark Lord Guard',
    troop: 'archer/development',
    materials: [
      { m: 'Black Iron', q: 1 },
      { m: 'Palm Leaf', q: 1 },
      { m: 'Steel Ingot', q: 1 },
      { m: 'Wolf Fang', q: 1 },
      { m: 'Palm Leaf', q: 1 },
      { m: 'Soul Cloth', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 15.2 },
          { statDesc: 'Archer Attack', stat: 15.2 },
          { statDesc: 'Stamina Recovery', stat: 15.2 },
          { statDesc: 'Monster Attack Speed', stat: 30.4 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 19 },
          { statDesc: 'Archer Attack', stat: 19 },
          { statDesc: 'Stamina Recovery', stat: 19 },
          { statDesc: 'Monster Attack Speed', stat: 38 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Helmet',
    desc: 'Templar Crown',
    troop: 'cavalry',
    materials: [
      { m: 'Black Iron', q: 1 },
      { m: 'Agate', q: 1 },
      { m: 'Soul Stone', q: 1 },
      { m: 'Soul Stone', q: 1 },
      { m: 'Fine Leather', q: 1 },
      { m: 'Feather', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Cavalry HP', stat: 15.2 },
          { statDesc: 'Cavalry HP', stat: 15.2 },
          { statDesc: 'Recruitment Speed Up', stat: 10.6 },
          { statDesc: 'Army Size Limit', stat: 2400 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Cavalry HP', stat: 19 },
          { statDesc: 'Cavalry HP', stat: 19 },
          { statDesc: 'Recruitment Speed Up', stat: 13.3 },
          { statDesc: 'Army Size Limit', stat: 3000 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Helmet',
    desc: 'Dragonscale Crown',
    troop: 'infantry',
    materials: [
      { m: 'Magic Spar', q: 1 },
      { m: 'Fine Leather', q: 1 },
      { m: 'Agate', q: 1 },
      { m: 'Crystal', q: 1 },
      { m: 'Soul Cloth', q: 1 },
      { m: 'Agate', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Mage HP', stat: 15.2 },
          { statDesc: 'Infantry HP', stat: 15.2 },
          { statDesc: 'Golem HP', stat: 22.8 },
          { statDesc: 'Healing Speed', stat: 15.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Mage HP', stat: 19 },
          { statDesc: 'Infantry HP', stat: 19 },
          { statDesc: 'Golem HP', stat: 28.5 },
          { statDesc: 'Healing Speed', stat: 19 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Helmet',
    desc: 'Crown of Praise',
    troop: 'infantry',
    materials: [
      { m: 'Soul Cloth', q: 1 },
      { m: 'Crystal', q: 1 },
      { m: 'Lumber', q: 1 },
      { m: 'Crystal', q: 1 },
      { m: 'Feather', q: 1 },
      { m: 'Fine Leather', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Archer HP', stat: 15.2 },
          { statDesc: 'Infantry HP', stat: 15.2 },
          { statDesc: 'Infantry HP', stat: 15.2 },
          { statDesc: 'March Speed', stat: 15.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Archer HP', stat: 19 },
          { statDesc: 'Infantry HP', stat: 19 },
          { statDesc: 'Infantry HP', stat: 19 },
          { statDesc: 'March Speed', stat: 19 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Clothes',
    desc: 'Dragonscale Armor',
    troop: 'cavalry',
    materials: [
      { m: 'Crystal', q: 1 },
      { m: 'Rope', q: 1 },
      { m: 'Feather', q: 1 },
      { m: 'Fine Leather', q: 1 },
      { m: 'Soul Cloth', q: 1 },
      { m: 'Soul Cloth', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Archer Defense', stat: 15.2 },
          { statDesc: 'Cavalry Defense', stat: 15.2 },
          { statDesc: 'Load Boost', stat: 25.8 },
          { statDesc: 'Healing Speed', stat: 15.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Archer Defense', stat: 19 },
          { statDesc: 'Cavalry Defense', stat: 19 },
          { statDesc: 'Load Boost', stat: 32.3 },
          { statDesc: 'Healing Speed', stat: 19 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Clothes',
    desc: 'Armor of Hymns',
    troop: 'cavalry',
    materials: [
      { m: 'Thick Hide', q: 1 },
      { m: 'Magic Spar', q: 1 },
      { m: 'Magic Spar', q: 1 },
      { m: 'Fine Leather', q: 1 },
      { m: 'Palm Leaf', q: 1 },
      { m: 'Fine Leather', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Mage Defense', stat: 15.2 },
          { statDesc: 'Cavalry Defense', stat: 15.2 },
          { statDesc: 'Building Speed', stat: 15.2 },
          { statDesc: 'Stamina Recovery', stat: 15.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Mage Defense', stat: 19 },
          { statDesc: 'Cavalry Defense', stat: 19 },
          { statDesc: 'Building Speed', stat: 19 },
          { statDesc: 'Stamina Recovery', stat: 19 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Clothes',
    desc: 'Templar Armor',
    troop: 'infantry',
    materials: [
      { m: 'Rope', q: 1 },
      { m: 'Agate', q: 1 },
      { m: 'Soul Cloth', q: 1 },
      { m: 'Soul Cloth', q: 1 },
      { m: 'Feather', q: 1 },
      { m: 'Feather', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Defense', stat: 15.2 },
          { statDesc: 'Infantry Defense', stat: 15.2 },
          { statDesc: 'Recruitment Speed Up', stat: 10.6 },
          { statDesc: 'March Speed', stat: 15.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Defense', stat: 19 },
          { statDesc: 'Infantry Defense', stat: 19 },
          { statDesc: 'Recruitment Speed Up', stat: 13.3 },
          { statDesc: 'March Speed', stat: 19 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Boots',
    desc: 'Sacred Boots',
    troop: 'monsters',
    materials: [
      { m: 'Magic Spar', q: 1 },
      { m: 'Palm Leaf', q: 1 },
      { m: 'Lumber', q: 1 },
      { m: 'Agate', q: 1 },
      { m: 'Palm Leaf', q: 1 },
      { m: 'Crystal', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Archer HP', stat: 15.2 },
          { statDesc: 'Mage HP', stat: 15.2 },
          { statDesc: 'Monster Attack Speed', stat: 30.4 },
          { statDesc: 'Stamina Recovery', stat: 15.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Archer HP', stat: 19 },
          { statDesc: 'Mage HP', stat: 19 },
          { statDesc: 'Monster Attack Speed', stat: 38 },
          { statDesc: 'Stamina Recovery', stat: 19 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Boots',
    desc: 'Dusk Boots',
    troop: 'archer',
    materials: [
      { m: 'Lumber', q: 1 },
      { m: 'Rope', q: 1 },
      { m: 'Steel Ingot', q: 1 },
      { m: 'Wolf Fang', q: 1 },
      { m: 'Thick Hide', q: 1 },
      { m: 'Soul Cloth', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 15.2 },
          { statDesc: 'Archer Attack', stat: 15.2 },
          { statDesc: 'Load Boost', stat: 25.8 },
          { statDesc: 'Gather Speed Boost', stat: 21.2 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 19 },
          { statDesc: 'Archer Attack', stat: 19 },
          { statDesc: 'Load Boost', stat: 32.3 },
          { statDesc: 'Gather Speed Boost', stat: 26.6 }
        ]
      }
    ]
  },
  {
    level: 30,
    type: 'Boots',
    desc: 'Dragonrider Boots',
    troop: 'development',
    materials: [
      { m: 'Palm Leaf', q: 1 },
      { m: 'Rope', q: 1 },
      { m: 'Fine Leather', q: 1 },
      { m: 'Steel Ingot', q: 1 },
      { m: 'Soul Stone', q: 1 },
      { m: 'Agate', q: 1 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Golem HP', stat: 22.8 },
          { statDesc: 'Golem Attack', stat: 22.8 },
          { statDesc: 'Golem Defense', stat: 22.8 },
          { statDesc: 'Wounded Limit Boost', stat: 16.7 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Golem HP', stat: 28.5 },
          { statDesc: 'Golem Attack', stat: 28.5 },
          { statDesc: 'Golem Defense', stat: 28.5 },
          { statDesc: 'Wounded Limit Boost', stat: 20.9 }
        ]
      }
    ]
  },
  {
    level: 35,
    type: 'Belt',
    desc: 'Radiance Belt',
    troop: 'archer',
    materials: [
      { m: 'Rope', q: 2 },
      { m: 'Wolf Fang', q: 2 },
      { m: 'Thick Hide', q: 2 },
      { m: 'Crystal', q: 2 },
      { m: 'Soul Stone', q: 2 },
      { m: 'Steel Ingot', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Archer Attack', stat: 16.7 },
          { statDesc: 'Cavalry HP', stat: 16.7 },
          { statDesc: 'Angel HP', stat: 16.7 },
          { statDesc: 'Wounded Limit Boost', stat: 18.9 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Archer Attack', stat: 21 },
          { statDesc: 'Cavalry HP', stat: 21 },
          { statDesc: 'Angel HP', stat: 21 },
          { statDesc: 'Wounded Limit Boost', stat: 23.7 }
        ]
      }
    ]
  },
  {
    level: 35,
    type: 'Belt',
    desc: 'Eternity Belt',
    troop: 'mage',
    materials: [
      { m: 'Soul Cloth', q: 2 },
      { m: 'Black Iron', q: 2 },
      { m: 'Thick Hide', q: 2 },
      { m: 'Crystal', q: 2 },
      { m: 'Rope', q: 2 },
      { m: 'Magic Spar', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 16.7 },
          { statDesc: 'Mage Attack', stat: 16.7 },
          { statDesc: 'Angel Limit', stat: 1800 },
          { statDesc: 'Research Speed', stat: 17.6 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 21 },
          { statDesc: 'Mage Attack', stat: 21 },
          { statDesc: 'Angel Limit', stat: 2200 },
          { statDesc: 'Research Speed', stat: 22 }
        ]
      }
    ]
  },
  {
    level: 35,
    type: 'Accessory',
    desc: 'Chaos Bracelet',
    troop: 'mage',
    materials: [
      { m: 'Soul Cloth', q: 2 },
      { m: 'Black Iron', q: 2 },
      { m: 'Agate', q: 2 },
      { m: 'Magic Spar', q: 2 },
      { m: 'Crystal', q: 2 },
      { m: 'Feather', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry HP', stat: 16.7 },
          { statDesc: 'Mage Attack', stat: 16.7 },
          { statDesc: 'Angel HP', stat: 16.7 },
          { statDesc: 'Building Speed', stat: 17.6 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry HP', stat: 21 },
          { statDesc: 'Mage Attack', stat: 21 },
          { statDesc: 'Angel HP', stat: 21 },
          { statDesc: 'Building Speed', stat: 22 }
        ]
      }
    ]
  },
  {
    level: 35,
    type: 'Accessory',
    desc: 'Perfect Heart',
    troop: 'archer',
    materials: [
      { m: 'Bone', q: 2 },
      { m: 'Lumber', q: 2 },
      { m: 'Agate', q: 2 },
      { m: 'Magic Spar', q: 2 },
      { m: 'Soul Stone', q: 2 },
      { m: 'Palm Leaf', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 16.7 },
          { statDesc: 'Archer Attack', stat: 16.7 },
          { statDesc: 'Angel Attack', stat: 16.7 },
          { statDesc: 'Golem Defense', stat: 26.5 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 21 },
          { statDesc: 'Archer Attack', stat: 21 },
          { statDesc: 'Angel Attack', stat: 21 },
          { statDesc: 'Golem Defense', stat: 33.1 }
        ]
      }
    ]
  },
  {
    level: 35,
    type: 'Helmet',
    desc: 'Royal Crown',
    troop: 'cavalry',
    materials: [
      { m: 'Thick Hide', q: 2 },
      { m: 'Black Iron', q: 2 },
      { m: 'Feather', q: 2 },
      { m: 'Soul Stone', q: 2 },
      { m: 'Magic Spar', q: 2 },
      { m: 'Agate', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Cavalry HP', stat: 16.7 },
          { statDesc: 'Cavalry HP', stat: 16.7 },
          { statDesc: 'Army Size Limit', stat: 2900 },
          { statDesc: 'Angel Limit', stat: 1800 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Cavalry HP', stat: 21 },
          { statDesc: 'Cavalry HP', stat: 21 },
          { statDesc: 'Army Size Limit', stat: 3600 },
          { statDesc: 'Angel Limit', stat: 2200 }
        ]
      }
    ]
  },
  {
    level: 35,
    type: 'Helmet',
    desc: 'Dominator Mask',
    troop: 'infantry',
    materials: [
      { m: 'Wolf Fang', q: 2 },
      { m: 'Lumber', q: 2 },
      { m: 'Feather', q: 2 },
      { m: 'Soul Stone', q: 2 },
      { m: 'Palm Leaf', q: 2 },
      { m: 'Fine Leather', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry HP', stat: 16.7 },
          { statDesc: 'Infantry HP', stat: 16.7 },
          { statDesc: 'Archer HP', stat: 16.7 },
          { statDesc: 'March Speed', stat: 17.6 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry HP', stat: 21 },
          { statDesc: 'Infantry HP', stat: 21 },
          { statDesc: 'Archer HP', stat: 21 },
          { statDesc: 'March Speed', stat: 22 }
        ]
      }
    ]
  },
  {
    level: 35,
    type: 'Clothes',
    desc: 'Titan Armor',
    troop: 'infantry',
    materials: [
      { m: 'Crystal', q: 2 },
      { m: 'Black Iron', q: 2 },
      { m: 'Soul Cloth', q: 2 },
      { m: 'Fine Leather', q: 2 },
      { m: 'Rope', q: 2 },
      { m: 'Wolf Fang', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Defense', stat: 16.7 },
          { statDesc: 'Mage HP', stat: 16.7 },
          { statDesc: 'Angel Defense', stat: 16.7 },
          { statDesc: 'Golem Defense', stat: 26.5 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Defense', stat: 21 },
          { statDesc: 'Mage HP', stat: 21 },
          { statDesc: 'Angel Defense', stat: 21 },
          { statDesc: 'Golem Defense', stat: 33.1 }
        ]
      }
    ]
  },
  {
    level: 35,
    type: 'Clothes',
    desc: 'Celestial Armor',
    troop: 'cavalry',
    materials: [
      { m: 'Bone', q: 2 },
      { m: 'Thick Hide', q: 2 },
      { m: 'Soul Cloth', q: 2 },
      { m: 'Fine Leather', q: 2 },
      { m: 'Feather', q: 2 },
      { m: 'Steel Ingot', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Cavalry Defense', stat: 16.7 },
          { statDesc: 'Cavalry Defense', stat: 16.7 },
          { statDesc: 'Load Boost', stat: 29.9 },
          { statDesc: 'Stamina Recovery', stat: 17.6 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Cavalry Defense', stat: 21 },
          { statDesc: 'Cavalry Defense', stat: 21 },
          { statDesc: 'Load Boost', stat: 37.4 },
          { statDesc: 'Stamina Recovery', stat: 22 }
        ]
      }
    ]
  },
  {
    level: 35,
    type: 'Boots',
    desc: 'Monarch Boots',
    troop: 'cavalry',
    materials: [
      { m: 'Feather', q: 2 },
      { m: 'Steel Ingot', q: 2 },
      { m: 'Rope', q: 2 },
      { m: 'Palm Leaf', q: 2 },
      { m: 'Thick Hide', q: 2 },
      { m: 'Bone', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 16.7 },
          { statDesc: 'Mage HP', stat: 16.7 },
          { statDesc: 'Cavalry HP', stat: 16.7 },
          { statDesc: 'Golem Defense', stat: 26.5 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 21 },
          { statDesc: 'Mage HP', stat: 21 },
          { statDesc: 'Cavalry HP', stat: 21 },
          { statDesc: 'Golem Defense', stat: 33.1 }
        ]
      }
    ]
  },
  {
    level: 35,
    type: 'Boots',
    desc: 'Dragonhide Boots',
    troop: 'monsters',
    materials: [
      { m: 'Soul Cloth', q: 2 },
      { m: 'Lumber', q: 2 },
      { m: 'Rope', q: 2 },
      { m: 'Palm Leaf', q: 2 },
      { m: 'Fine Leather', q: 2 },
      { m: 'Agate', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 16.7 },
          { statDesc: 'Archer HP', stat: 16.7 },
          { statDesc: 'Monster Attack Speed', stat: 35.2 },
          { statDesc: 'Stamina Recovery', stat: 16.7 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 21 },
          { statDesc: 'Archer HP', stat: 21 },
          { statDesc: 'Monster Attack Speed', stat: 44 },
          { statDesc: 'Stamina Recovery', stat: 22 }
        ]
      }
    ]
  },
  {
    level: 40,
    type: 'Belt',
    desc: 'Sage Belt',
    troop: 'mage',
    materials: [
      { m: 'Rope', q: 2 },
      { m: 'Black Iron', q: 2 },
      { m: 'Thick Hide', q: 2 },
      { m: 'Crystal', q: 2 },
      { m: 'Soul Cloth', q: 2 },
      { m: 'Magic Spar', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 18.9 },
          { statDesc: 'Mage Attack', stat: 18.9 },
          { statDesc: 'Angel Limit', stat: 2100 },
          { statDesc: 'Research Speed', stat: 20 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 23.8 },
          { statDesc: 'Mage Attack', stat: 23.8 },
          { statDesc: 'Angel Limit', stat: 2600 },
          { statDesc: 'Research Speed', stat: 25 }
        ]
      }
    ]
  },
  {
    level: 40,
    type: 'Belt',
    desc: 'Guardian Belt',
    troop: 'archer',
    materials: [
      { m: 'Soul Stone', q: 2 },
      { m: 'Wolf Fang', q: 2 },
      { m: 'Thick Hide', q: 2 },
      { m: 'Crystal', q: 2 },
      { m: 'Steel Ingot', q: 2 },
      { m: 'Rope', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Archer Attack', stat: 18.9 },
          { statDesc: 'Cavalry HP', stat: 18.9 },
          { statDesc: 'Angel Limit', stat: 2100 },
          { statDesc: 'Wounded Limit Boost', stat: 21.1 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Archer Attack', stat: 23.8 },
          { statDesc: 'Cavalry HP', stat: 23.8 },
          { statDesc: 'Angel Limit', stat: 2600 },
          { statDesc: 'Wounded Limit Boost', stat: 26.5 }
        ]
      }
    ]
  },
  {
    level: 40,
    type: 'Accessory',
    desc: 'Dragon Tooth Necklace',
    troop: 'mage',
    materials: [
      { m: 'Soul Stone', q: 2 },
      { m: 'Soul Cloth', q: 2 },
      { m: 'Agate', q: 2 },
      { m: 'Magic Spar', q: 2 },
      { m: 'Feather', q: 2 },
      { m: 'Bone', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry HP', stat: 18.9 },
          { statDesc: 'Mage Attack', stat: 18.9 },
          { statDesc: 'Angel HP', stat: 18.9 },
          { statDesc: 'Recruitment Speed Up', stat: 14 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry HP', stat: 23.8 },
          { statDesc: 'Mage Attack', stat: 23.8 },
          { statDesc: 'Angel HP', stat: 23.8 },
          { statDesc: 'Recruitment Speed Up', stat: 17.5 }
        ]
      }
    ]
  },
  {
    level: 40,
    type: 'Accessory',
    desc: 'Lionheart Ring',
    troop: 'archer',
    materials: [
      { m: 'Lumber', q: 2 },
      { m: 'Black Iron', q: 2 },
      { m: 'Agate', q: 2 },
      { m: 'Magic Spar', q: 2 },
      { m: 'Crystal', q: 2 },
      { m: 'Palm Leaf', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry HP', stat: 18.9 },
          { statDesc: 'Archer Attack', stat: 18.9 },
          { statDesc: 'Angel HP', stat: 18.9 },
          { statDesc: 'Gollem HP', stat: 30.4 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry HP', stat: 23.8 },
          { statDesc: 'Archer Attack', stat: 23.8 },
          { statDesc: 'Angel HP', stat: 23.8 },
          { statDesc: 'Gollem HP', stat: 37.9 }
        ]
      }
    ]
  },
  {
    level: 40,
    type: 'Helmet',
    desc: 'Dragon Tooth Crown',
    troop: 'infantry',
    materials: [
      { m: 'Wolf Fang', q: 2 },
      { m: 'Palm Leaf', q: 2 },
      { m: 'Feather', q: 2 },
      { m: 'Soul Stone', q: 2 },
      { m: 'Thick Hide', q: 2 },
      { m: 'Agate', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry HP', stat: 18.9 },
          { statDesc: 'Infantry HP', stat: 18.9 },
          { statDesc: 'Archer HP', stat: 18.9 },
          { statDesc: 'March Speed', stat: 20 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry HP', stat: 23.8 },
          { statDesc: 'Infantry HP', stat: 23.8 },
          { statDesc: 'Archer HP', stat: 23.8 },
          { statDesc: 'March Speed', stat: 25 }
        ]
      }
    ]
  },
  {
    level: 40,
    type: 'Helmet',
    desc: 'Guardian Helmet',
    troop: 'cavalry',
    materials: [
      { m: 'Magic Spar', q: 2 },
      { m: 'Black Iron', q: 2 },
      { m: 'Feather', q: 2 },
      { m: 'Soul Stone', q: 2 },
      { m: 'Lumber', q: 2 },
      { m: 'Fine Leather', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Cavalry HP', stat: 18.9 },
          { statDesc: 'Cavalry HP', stat: 18.9 },
          { statDesc: 'Army Size Limit', stat: 3500 },
          { statDesc: 'Recruitment Speed Up', stat: 14 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Cavalry HP', stat: 23.8 },
          { statDesc: 'Cavalry HP', stat: 23.8 },
          { statDesc: 'Army Size Limit', stat: 4300 },
          { statDesc: 'Recruitment Speed Up', stat: 17.5 }
        ]
      }
    ]
  },
  {
    level: 40,
    type: 'Clothes',
    desc: 'Gold Dragon Armor',
    troop: 'infantry',
    materials: [
      { m: 'Bone', q: 2 },
      { m: 'Wolf Fang', q: 2 },
      { m: 'Soul Cloth', q: 2 },
      { m: 'Fine Leather', q: 2 },
      { m: 'Wolf Fang', q: 2 },
      { m: 'Thick Hide', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Defense', stat: 18.9 },
          { statDesc: 'Mage HP', stat: 18.9 },
          { statDesc: 'Angel Defense', stat: 18.9 },
          { statDesc: 'Golem Defense', stat: 30.4 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Defense', stat: 23.8 },
          { statDesc: 'Mage HP', stat: 23.8 },
          { statDesc: 'Angel Defense', stat: 23.8 },
          { statDesc: 'Golem Defense', stat: 37.9 }
        ]
      }
    ]
  },
  {
    level: 40,
    type: 'Clothes',
    desc: 'Guardian Breastplate',
    troop: 'cavalry',
    materials: [
      { m: 'Feather', q: 2 },
      { m: 'Black Iron', q: 2 },
      { m: 'Soul Cloth', q: 2 },
      { m: 'Fine Leather', q: 2 },
      { m: 'Steel Ingot', q: 2 },
      { m: 'Crystal', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Cavalry Defense', stat: 18.9 },
          { statDesc: 'Cavalry Defense', stat: 18.9 },
          { statDesc: 'Angel Attack', stat: 18.9 },
          { statDesc: 'Stamina Recovery', stat: 20 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Cavalry Defense', stat: 23.8 },
          { statDesc: 'Cavalry Defense', stat: 23.8 },
          { statDesc: 'Angel Attack', stat: 23.8 },
          { statDesc: 'Stamina Recovery', stat: 25 }
        ]
      }
    ]
  },
  {
    level: 40,
    type: 'Boots',
    desc: 'Dragon Bone Leg Guard',
    troop: 'development',
    materials: [
      { m: 'Bone', q: 2 },
      { m: 'Fine Leather', q: 2 },
      { m: 'Rope', q: 2 },
      { m: 'Palm Leaf', q: 2 },
      { m: 'Thick Hide', q: 2 },
      { m: 'Lumber', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Infantry Attack', stat: 18.9 },
          { statDesc: 'Archer HP', stat: 18.9 },
          { statDesc: 'Mage HP', stat: 18.9 },
          { statDesc: 'Stamina Recovery', stat: 20 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Infantry Attack', stat: 23.8 },
          { statDesc: 'Archer HP', stat: 23.8 },
          { statDesc: 'Mage HP', stat: 23.8 },
          { statDesc: 'Stamina Recovery', stat: 25 }
        ]
      }
    ]
  },
  {
    level: 40,
    type: 'Boots',
    desc: 'Guardian Boots',
    troop: 'cavalry',
    materials: [
      { m: 'Agate', q: 2 },
      { m: 'Soul Cloth', q: 2 },
      { m: 'Rope', q: 2 },
      { m: 'Palm Leaf', q: 2 },
      { m: 'Steel Ingot', q: 2 },
      { m: 'Feather', q: 2 }
    ],
    levels: [
      {
        quality: 'Purple',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 18.9 },
          { statDesc: 'Archer HP', stat: 18.9 },
          { statDesc: 'Cavalry HP', stat: 18.9 },
          { statDesc: 'Golem Defense', stat: 30 }
        ]
      },
      {
        quality: 'Orange',
        stats: [
          { statDesc: 'Cavalry Attack', stat: 23.8 },
          { statDesc: 'Archer HP', stat: 23.8 },
          { statDesc: 'Cavalry HP', stat: 23.8 },
          { statDesc: 'Golem Defense', stat: 37.9 }
        ]
      }
    ]
  }
]

export const equipmentSlots = [
  {
    key: 1,
    quality: 'Orange',
    slotDesc: 'Weapon',
    type: 1,
    level: 1,
    expNeeded: 0,
    from: 0,
    to: 0,
    shardsNeeded: 0,
    fromStar: 0,
    toStar: 0,
    maxLevel: 30,
    minLevel: 1,
    selectedRank: { star: 4, rank: 0 },
    artifact: {},
    equipment: {},
    enhancement: {},
    eLevel: 0,
    eStat: 0,
    obsidian: 0
  },
  {
    key: 2,
    quality: '',
    slotDesc: 'Belt',
    type: 1,
    level: 1,
    expNeeded: 0,
    from: 0,
    to: 0,
    shardsNeeded: 0,
    fromStar: { star: 1, rank: 0 },
    toStar: { star: 1, rank: 0 },
    maxLevel: 30,
    minLevel: 1,
    selectedRank: {},
    artifact: {},
    equipment: {},
    enhancement: {},
    eLevel: 0,
    eStat: 0,
    obsidian: 0
  },
  {
    key: 3,
    quality: '',
    slotDesc: 'Accessory',
    type: 1,
    level: 1,
    expNeeded: 0,
    from: 0,
    to: 0,
    shardsNeeded: 0,
    fromStar: { star: 1, rank: 0 },
    toStar: { star: 1, rank: 0 },
    maxLevel: 30,
    minLevel: 1,
    selectedRank: {},
    artifact: {},
    equipment: {},
    enhancement: {},
    eLevel: 0,
    eStat: 0,
    obsidian: 0
  },
  {
    key: 4,
    quality: '',
    slotDesc: 'Helmet',
    type: 1,
    level: 1,
    expNeeded: 0,
    from: 0,
    to: 0,
    shardsNeeded: 0,
    fromStar: { star: 1, rank: 0 },
    toStar: { star: 1, rank: 0 },
    maxLevel: 30,
    minLevel: 1,
    selectedRank: {},
    artifact: {},
    equipment: {},
    enhancement: {},
    eLevel: 0,
    eStat: 0,
    obsidian: 0
  },
  {
    key: 5,
    quality: '',
    slotDesc: 'Clothes',
    type: 1,
    level: 1,
    expNeeded: 0,
    from: 0,
    to: 0,
    shardsNeeded: 0,
    fromStar: { star: 1, rank: 0 },
    toStar: { star: 1, rank: 0 },
    maxLevel: 30,
    minLevel: 1,
    selectedRank: {},
    artifact: {},
    equipment: {},
    enhancement: {},
    eLevel: 0,
    eStat: 0,
    obsidian: 0
  },
  {
    key: 6,
    quality: '',
    slotDesc: 'Boots',
    type: 1,
    level: 1,
    expNeeded: 0,
    from: 0,
    to: 0,
    shardsNeeded: 0,
    fromStar: { star: 1, rank: 0 },
    toStar: { star: 1, rank: 0 },
    maxLevel: 30,
    minLevel: 1,
    selectedRank: {},
    artifact: {},
    equipment: {},
    enhancement: {},
    eLevel: 0,
    eStat: 0,
    obsidian: 0
  }
]

export const equipmentTemplates = [
  { key: 'custom', desc: 'Custom', config: [] },
  {
    key: 'mage_inf25',
    desc: 'Mage / Infantry',
    type: 'WAR',
    level: 25,
    config: [
      { key: 'Weapon', value: 'Heart of Karlos' },
      { key: 'Belt', value: 'Blood Belt' },
      { key: 'Accessory', value: 'Brave Heart' },
      { key: 'Helmet', value: 'Element Helmet' },
      { key: 'Clothes', value: 'Shining Armor' },
      { key: 'Boots', value: 'Blood Boots' }
    ]
  },
  {
    key: 'mage_cav25',
    desc: 'Mage / Cavalry',
    type: 'WAR',
    level: 25,
    config: [
      { key: 'Weapon', value: 'Heart of Karlos' },
      { key: 'Belt', value: 'Blood Belt' },
      { key: 'Accessory', value: 'Brave Heart' },
      { key: 'Helmet', value: 'Blood Helmet' },
      { key: 'Clothes', value: 'Shining Armor' },
      { key: 'Boots', value: 'Blood Boots' }
    ]
  },
  {
    key: 'archer_inf25',
    desc: 'Archer / Infantry',
    type: 'WAR',
    level: 25,
    config: [
      { key: 'Weapon', value: 'Elemental Power' },
      { key: 'Belt', value: 'Element Belt' },
      { key: 'Accessory', value: 'Brave Heart' },
      { key: 'Helmet', value: 'Element Helmet' },
      { key: 'Clothes', value: 'Elven Armor' },
      { key: 'Boots', value: 'Blood Boots' }
    ]
  },
  {
    key: 'archer_cav25',
    desc: 'Archer / Cavalry',
    type: 'WAR',
    level: 25,
    config: [
      { key: 'Weapon', value: 'Elemental Power' },
      { key: 'Belt', value: 'Element Belt' },
      { key: 'Accessory', value: 'Blood Ring' },
      { key: 'Helmet', value: 'Blood Helmet' },
      { key: 'Clothes', value: 'Elven Armor' },
      { key: 'Boots', value: 'Blood Boots' }
    ]
  },
  {
    key: 'recruitment25',
    desc: 'Recruitment',
    type: 'DEVELOPMENT',
    level: 25,
    config: [
      { key: 'Weapon', value: 'Traitors Kiss' },
      { key: 'Belt', value: 'Resilient Belt' },
      { key: 'Accessory', value: '' },
      { key: 'Helmet', value: 'Occult Helmet' },
      { key: 'Clothes', value: 'Shining Armor' },
      { key: 'Boots', value: '' }
    ]
  },
  {
    key: 'building25',
    desc: 'Building',
    type: 'DEVELOPMENT',
    level: 25,
    config: [
      { key: 'Weapon', value: '' },
      { key: 'Belt', value: '' },
      { key: 'Accessory', value: 'Thorn Stone' },
      { key: 'Helmet', value: '' },
      { key: 'Clothes', value: '' },
      { key: 'Boots', value: '' }
    ]
  },
  {
    key: 'monster25',
    desc: 'Monsters',
    type: 'DEVELOPMENT',
    level: 25,
    config: [
      { key: 'Weapon', value: '' },
      { key: 'Belt', value: 'Resilient Belt' },
      { key: 'Accessory', value: 'Brave Heart' },
      { key: 'Helmet', value: '' },
      { key: 'Clothes', value: 'Blood Armor' },
      { key: 'Boots', value: 'Blood Boots' }
    ]
  },
  {
    key: 'wounded25',
    desc: 'Wounded / Healing',
    type: 'DEVELOPMENT',
    level: 25,
    config: [
      { key: 'Weapon', value: '' },
      { key: 'Belt', value: 'Element Belt' },
      { key: 'Accessory', value: 'Blood Ring' },
      { key: 'Helmet', value: 'Occult Helmet' },
      { key: 'Clothes', value: 'Shining Armor' },
      { key: 'Boots', value: 'Armored Boots' }
    ]
  },
  {
    key: 'mage_inf30',
    desc: 'Mage / Infantry',
    type: 'WAR',
    level: 30,
    config: [
      { key: 'Weapon', value: 'Holy Crossbow' },
      { key: 'Belt', value: 'Sacred belt' },
      { key: 'Accessory', value: 'Holy Blessing' },
      { key: 'Helmet', value: 'Crown of Praise' },
      { key: 'Clothes', value: 'Templar Armor' },
      { key: 'Boots', value: 'Sacred Boots' }
    ]
  },
  {
    key: 'mage_cav30',
    desc: 'Mage / Cavalry',
    type: 'WAR',
    level: 30,
    config: [
      { key: 'Weapon', value: 'Holy Crossbow' },
      { key: 'Belt', value: 'Sacred belt' },
      { key: 'Accessory', value: 'Holy Blessing' },
      { key: 'Helmet', value: 'Templar Crown' },
      { key: 'Clothes', value: 'Armor of Hymns' },
      { key: 'Boots', value: 'Sacred Boots' }
    ]
  },
  {
    key: 'archer_inf30',
    desc: 'Archer / Infantry',
    type: 'WAR',
    level: 30,
    config: [
      { key: 'Weapon', value: 'Dusk Ode' },
      { key: 'Belt', value: 'Blessing Belt' },
      { key: 'Accessory', value: 'Dark Lord Guard' },
      { key: 'Helmet', value: 'Crown of Praise' },
      { key: 'Clothes', value: 'Templar Armor' },
      { key: 'Boots', value: 'Dusk Boots' }
    ]
  },
  {
    key: 'archer_cav30',
    desc: 'Archer / Cavalry',
    type: 'WAR',
    level: 30,
    config: [
      { key: 'Weapon', value: 'Dusk Ode' },
      { key: 'Belt', value: 'Blessing Belt' },
      { key: 'Accessory', value: 'Dark Lord Guard' },
      { key: 'Helmet', value: 'Templar Crown' },
      { key: 'Clothes', value: 'Dragonscale Armor' },
      { key: 'Boots', value: 'Dusk Boots' }
    ]
  },
  {
    key: 'recruitment30',
    desc: 'Recruitment',
    type: 'DEVELOPMENT',
    level: 30,
    config: [
      { key: 'Weapon', value: 'Holy Crossbow' },
      { key: 'Belt', value: 'Dragonscale Belt' },
      { key: 'Accessory', value: '' },
      { key: 'Helmet', value: 'Templar Crown' },
      { key: 'Clothes', value: 'Templar Armor' },
      { key: 'Boots', value: '' }
    ]
  },
  {
    key: 'building30',
    desc: 'Building',
    type: 'DEVELOPMENT',
    level: 30,
    config: [
      { key: 'Weapon', value: '' },
      { key: 'Belt', value: 'Sacred belt' },
      { key: 'Accessory', value: 'Holy Blessing' },
      { key: 'Helmet', value: '' },
      { key: 'Clothes', value: 'Armor of Hymns' },
      { key: 'Boots', value: '' }
    ]
  },
  {
    key: 'monster30',
    desc: 'Monsters',
    type: 'DEVELOPMENT',
    level: 30,
    config: [
      { key: 'Weapon', value: '' },
      { key: 'Belt', value: 'Dragonscale Belt' },
      { key: 'Accessory', value: 'Dark Lord Guard' },
      { key: 'Helmet', value: '' },
      { key: 'Clothes', value: 'Armor of Hymns' },
      { key: 'Boots', value: 'Sacred Boots' }
    ]
  },
  {
    key: 'wounded30',
    desc: 'Wounded / Healing',
    type: 'DEVELOPMENT',
    level: 30,
    config: [
      { key: 'Weapon', value: '' },
      { key: 'Belt', value: 'Blessing Belt' },
      { key: 'Accessory', value: 'Noble Badge' },
      { key: 'Helmet', value: 'Dragonscale Crown' },
      { key: 'Clothes', value: 'Dragonscale Armor' },
      { key: 'Boots', value: 'Dragonrider Boots' }
    ]
  },
  {
    key: 'mage_inf35',
    desc: 'Mage / Infantry',
    type: 'WAR',
    level: 35,
    config: [
      { key: 'Weapon', value: 'Mastery Staff' },
      { key: 'Belt', value: 'Eternity Belt' },
      { key: 'Accessory', value: 'Chaos Bracelet' },
      { key: 'Helmet', value: 'Dominator Mask' },
      { key: 'Clothes', value: 'Titan Armor' },
      { key: 'Boots', value: 'Dragonhide Boots' }
    ]
  },
  {
    key: 'mage_cav35',
    desc: 'Mage / Cavalry',
    type: 'WAR',
    level: 35,
    config: [
      { key: 'Weapon', value: 'Mastery Staff' },
      { key: 'Belt', value: 'Eternity Belt' },
      { key: 'Accessory', value: 'Chaos Bracelet' },
      { key: 'Helmet', value: 'Royal Crown' },
      { key: 'Clothes', value: 'Celestial Armor' },
      { key: 'Boots', value: 'Monarch Boots' }
    ]
  },
  {
    key: 'archer_inf35',
    desc: 'Archer / Infantry',
    type: 'WAR',
    level: 35,
    config: [
      { key: 'Weapon', value: 'Fiery Crossbow' },
      { key: 'Belt', value: 'Radiance Belt' },
      { key: 'Accessory', value: 'Perfect Heart' },
      { key: 'Helmet', value: 'Dominator Mask' },
      { key: 'Clothes', value: 'Titan Armor' },
      { key: 'Boots', value: 'Dragonhide Boots' }
    ]
  },
  {
    key: 'archer_cav35',
    desc: 'Archer / Cavalry',
    type: 'WAR',
    level: 35,
    config: [
      { key: 'Weapon', value: 'Fiery Crossbow' },
      { key: 'Belt', value: 'Radiance Belt' },
      { key: 'Accessory', value: 'Perfect Heart' },
      { key: 'Helmet', value: 'Royal Crown' },
      { key: 'Clothes', value: 'Celestial Armor' },
      { key: 'Boots', value: 'Monarch Boots' }
    ]
  },
  {
    key: 'building35',
    desc: 'Building',
    type: 'DEVELOPMENT',
    level: 35,
    config: [
      { key: 'Weapon', value: '' },
      { key: 'Belt', value: 'Sacred belt' },
      { key: 'Accessory', value: 'Chaos Bracelet' },
      { key: 'Helmet', value: '' },
      { key: 'Clothes', value: 'Armor of Hymns' },
      { key: 'Boots', value: '' }
    ]
  },
  {
    key: 'monster35',
    desc: 'Monsters',
    type: 'DEVELOPMENT',
    level: 35,
    config: [
      { key: 'Weapon', value: '' },
      { key: 'Belt', value: 'Dragonscale Belt' },
      { key: 'Accessory', value: 'Dark Lord Guard' },
      { key: 'Helmet', value: '' },
      { key: 'Clothes', value: 'Celestial Armor' },
      { key: 'Boots', value: 'Dragonhide Boots' }
    ]
  },
  {
    key: 'mage_inf40',
    desc: 'Mage / Infantry',
    type: 'WAR',
    level: 40,
    config: [
      { key: 'Weapon', value: 'Dragonshard Staff' },
      { key: 'Belt', value: 'Sage Belt' },
      { key: 'Accessory', value: 'Dragon Tooth Necklace' },
      { key: 'Helmet', value: 'Dragon Tooth Crown' },
      { key: 'Clothes', value: 'Gold Dragon Armor' },
      { key: 'Boots', value: 'Dragon Bone Leg Guard' }
    ]
  },
  {
    key: 'mage_cav40',
    desc: 'Mage / Cavalry',
    type: 'WAR',
    level: 40,
    config: [
      { key: 'Weapon', value: 'Dragonshard Staff' },
      { key: 'Belt', value: 'Sage Belt' },
      { key: 'Accessory', value: 'Dragon Tooth Necklace' },
      { key: 'Helmet', value: 'Guardian Helmet' },
      { key: 'Clothes', value: 'Guardian Breastplate' },
      { key: 'Boots', value: 'Guardian Boots' }
    ]
  },
  {
    key: 'archer_inf40',
    desc: 'Archer / Infantry',
    type: 'WAR',
    level: 40,
    config: [
      { key: 'Weapon', value: 'Dragon Scorch Sword' },
      { key: 'Belt', value: 'Guardian Belt' },
      { key: 'Accessory', value: 'Lionheart Ring' },
      { key: 'Helmet', value: 'Dragon Tooth Crown' },
      { key: 'Clothes', value: 'Gold Dragon Armor' },
      { key: 'Boots', value: 'Dragon Bone Leg Guard' }
    ]
  },
  {
    key: 'archer_cav40',
    desc: 'Archer / Cavalry',
    type: 'WAR',
    level: 40,
    config: [
      { key: 'Weapon', value: 'Dragon Scorch Sword' },
      { key: 'Belt', value: 'Guardian Belt' },
      { key: 'Accessory', value: 'Lionheart Ring' },
      { key: 'Helmet', value: 'Guardian Helmet' },
      { key: 'Clothes', value: 'Guardian Breastplate' },
      { key: 'Boots', value: 'Guardian Boots' }
    ]
  },
  {
    key: 'recruitment40',
    desc: 'Recruitment',
    type: 'DEVELOPMENT',
    level: 40,
    config: [
      { key: 'Weapon', value: 'Holy Crossbow' },
      { key: 'Belt', value: 'Dragonscale Belt' },
      { key: 'Accessory', value: 'Dragon Tooth Necklace' },
      { key: 'Helmet', value: 'Guardian Helmet' },
      { key: 'Clothes', value: 'Templar Armor' },
      { key: 'Boots', value: '' }
    ]
  },
  {
    key: 'monster40',
    desc: 'Monsters',
    type: 'DEVELOPMENT',
    level: 40,
    config: [
      { key: 'Weapon', value: '' },
      { key: 'Belt', value: 'Dragonscale Belt' },
      { key: 'Accessory', value: 'Dark Lord Guard' },
      { key: 'Helmet', value: '' },
      { key: 'Clothes', value: 'Guardian Breastplate' },
      { key: 'Boots', value: 'Dragon Bone Leg Guard' }
    ]
  }
]

export const enhancementTemplates = [
  { key: 'custom', desc: 'Custom', config: [] },
  {
    key: 'elite_war',
    desc: 'Elite War',
    type: 'WAR',
    config: [
      { key: 'Weapon', value: 'Damage Against Infantry Boost' },
      { key: 'Belt', value: 'Increases Damage during Elite War' },
      { key: 'Accessory', value: 'Increases Damage during Elite War' },
      { key: 'Helmet', value: 'Reduces Damage taken from Mages' },
      { key: 'Clothes', value: 'Reduces Damage taken from Angels' },
      { key: 'Boots', value: 'Damage Taken Reduction in Elite War' }
    ]
  },
  {
    key: 'attacking',
    desc: 'Attack (PvP)',
    type: 'WAR',
    config: [
      { key: 'Weapon', value: 'Damage Against Infantry Boost' },
      { key: 'Belt', value: 'Damage Boost when Attacking' },
      { key: 'Accessory', value: 'Damage Boost when Attacking' },
      { key: 'Helmet', value: 'Reduces Damage taken from Mages' },
      { key: 'Clothes', value: 'Reduces Damage taken from Angels' },
      { key: 'Boots', value: 'Damage Taken Reduced when attacking' }
    ]
  },
  {
    key: 'defense',
    desc: 'Defense (PvP)',
    type: 'WAR',
    config: [
      { key: 'Weapon', value: 'Damage Against Infantry Boost' },
      { key: 'Belt', value: 'Damage Boost when Defending' },
      { key: 'Accessory', value: 'Damage Boost when Defending' },
      { key: 'Helmet', value: 'Reduces Damage taken from Mages' },
      { key: 'Clothes', value: 'Reduces Damage taken from Angels' },
      { key: 'Boots', value: 'Damage Taken Reduced when defending' }
    ]
  },
  {
    key: 'realm_invasion',
    desc: 'Realm Invasion (PvP)',
    type: 'WAR',
    config: [
      { key: 'Weapon', value: 'Damage Against Infantry Boost' },
      { key: 'Belt', value: 'Increases Damage during Realm Invasion' },
      { key: 'Accessory', value: 'Increases Damage during Realm Invasion' },
      { key: 'Helmet', value: 'Reduces Damage taken from Mages' },
      { key: 'Clothes', value: 'Reduces Damage taken from Angels' },
      { key: 'Boots', value: 'Damage Taken Reduction in Realm Invasion' }
    ]
  },
  {
    key: 'development',
    desc: 'Development',
    type: 'WAR',
    config: [
      { key: 'Weapon', value: 'Stamina Recovery' },
      { key: 'Belt', value: 'Recruitment Speed Up' },
      { key: 'Accessory', value: 'Angel Limit' },
      { key: 'Helmet', value: 'Monster Attack Speed' },
      { key: 'Clothes', value: 'Recruitment Speed Up' },
      { key: 'Boots', value: 'Building Speed' }
    ]
  }
]

export const listItems = [
  { orden: 1, item: 'Agate' },
  { orden: 2, item: 'Fine Leather' },
  { orden: 3, item: 'Bone' },
  { orden: 4, item: 'Soul Stone' },
  { orden: 5, item: 'Crystal' },
  { orden: 6, item: 'Feather' },
  { orden: 7, item: 'Palm Leaf' },
  { orden: 8, item: 'Black Iron' },
  { orden: 9, item: 'Rope' },
  { orden: 10, item: 'Thick Hide' },
  { orden: 11, item: 'Lumber' },
  { orden: 12, item: 'Wolf Fang' },
  { orden: 13, item: 'Steel Ingot' },
  { orden: 14, item: 'Soul Cloth' },
  { orden: 15, item: 'Magic Spar' }
]
